import type { ReactNode } from "react";
import styles from "./table.module.css";

export { styles as tableStyles };

export type SortDir = "asc" | "desc";

/** Header cell with a sort toggle; `sort` is a field name, prefixed with "-" when descending. */
export function SortHeader({
  field,
  sort,
  onSort,
  children,
  align,
}: {
  field: string;
  sort: string;
  onSort: (next: string) => void;
  children: ReactNode;
  align?: "right";
}) {
  const active = sort.replace(/^-/, "") === field;
  const desc = sort.startsWith("-");
  return (
    <th data-align={align} aria-sort={active ? (desc ? "descending" : "ascending") : "none"}>
      <button
        type="button"
        className={styles.sort}
        data-active={active || undefined}
        onClick={() => onSort(active && !desc ? `-${field}` : field)}
      >
        {children}
        <span className={styles.sortArrow} aria-hidden>
          {active ? (desc ? "▼" : "▲") : "↕"}
        </span>
      </button>
    </th>
  );
}
